import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const conversationApi = {
  listMine: () => imRequest.get(`${IM_API}/conversations`),

  getById: (conversationId) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}`),

  getDirectCapability: (peerMemberId) =>
    imRequest.get(`${IM_API}/conversations/direct/capability`, { params: { peerMemberId } }),

  createOrGetDirect: (peerMemberId) =>
    imRequest.post(`${IM_API}/conversations/direct`, { peerMemberId }),
};
